import { FormTextInput } from '@components/form';
import * as yup from 'yup';

export const volumeNameSchema = yup
  .string()
  .trim()
  .max(128, 'Must be less than 128 characters')
  .required('Name is required');

export const VolumeNameField = () => {
  return <FormTextInput label="Name" name="name" />;
};
